var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMyBodyIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.484,
    height: 55.976,
    viewBox: "0 0 53.484 55.976",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "MyBody",
    d: "M64.818,64.614H18.709a3.78,3.78,0,0,1-3.775-3.775V55.444l9.394-23.372c.561-1.383,1.034-1.582,1.034-1.595.025.012.5.249.947,1.669l5.594,17.5c.86,2.691,2.143,3.277,3.077,3.3.909.05,2.243-.511,3.227-3.164L42.617,37.8c.461-1.246,1.022-1.719,1.358-1.744s.959.361,1.582,1.532l2.816,5.233c1.383,2.554,3,2.841,3.85,2.778s2.4-.573,3.4-3.3L63.46,20.748a1.194,1.194,0,1,0-2.243-.822L53.381,41.478c-.449,1.246-1.009,1.719-1.333,1.744-.361.025-.947-.361-1.582-1.532L47.65,36.458c-1.383-2.554-3-2.841-3.85-2.778s-2.417.573-3.426,3.289l-4.41,11.985a4.813,4.813,0,0,1-.885,1.62c-.112-.05-.523-.449-.909-1.657l-5.594-17.5c-.86-2.679-2.168-3.289-3.115-3.326s-2.292.473-3.351,3.09L14.922,49.053V12.226a1.2,1.2,0,1,0-2.392,0V60.839A6.173,6.173,0,0,0,18.7,67.006H64.818a1.2,1.2,0,0,0,0-2.392Z",
    transform: "translate(-12.53 -11.03)",
    fill: "#11a4de"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyBodyIcon);
export default __webpack_public_path__ + "static/media/my-body-icon.cbf8859484ff03ba894816aedb43154c.svg";
export { ForwardRef as ReactComponent };